import { FC } from 'react';
import { useApplication } from '../../../../../../context/ApplicationContext';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import React from 'react';
import { Typography } from '@mui/material';

import Schema from '../../../../../../lib/paths/zuwendungsantrag_Zuwendungsantrag_Paths.json';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat } from 'lodash';
import { get } from 'lodash';
import { isTrue } from '../../../../../../utils/helper';
const P = Schema.attributes;

const Projektbeschreibung: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	return (
		<>
			<Typography variant="h3">Projektdaten</Typography>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={ProjektDatenSpalte1(application, readOnly)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={ProjektDatenSpalte2()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
			</Grid2>

			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={ProjektbeschreibungSpalte1()}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={readOnly}
					/>
				</Grid2>
				<Grid2 sm={6}></Grid2>
			</Grid2>
			<CreateForm
				formStruc={ProjektbeschreibungTextboxen()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};

export default Projektbeschreibung;

const isKooperationFieldDisabled = (application: any, readOnly: boolean) => {
	if (readOnly) return true;
	const allPartners = get(application, P.Partner.path, []);
	return isTrue(get(application, P.Allgemein_Kooperationsprojekt.path)) && allPartners.length > 0 ? true : false;
};

const ProjektDatenSpalte1 = (application: any, readOnly: boolean) => {
	return [
		{
			fields: [P.Allgemein_Projekttitel],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [P.Allgemein_Geplanter_Durchfuehrungszeitraum_von, P.Allgemein_Geplanter_Durchfuehrungszeitraum_bis],
		},
		{
			fields: [{ ...P.Allgemein_Kooperationsprojekt, disabled: isKooperationFieldDisabled(application, readOnly) }],
			userProps: { columnToDivide: 1 },
		},
	];
};

const ProjektDatenSpalte2 = () => {
	return [
		{
			fields: [{ ...P.Allgemein_Projektstart_Jahr, disabled: true }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

const ProjektbeschreibungSpalte1 = () => {
	return [
		{
			fields: [P.Projektbeschreibung_Durchfuehrungsort_Stadtteil, P.Projektbeschreibung_Arbeitsmittelpunkt_Dortmundjanein],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

const ProjektbeschreibungTextboxen = () => {
	return [
		{
			fields: [
				P.Projektbeschreibung_Durchfuehrungsort_Zu_Foerderndes_Objekt,
				{ ...P.Projketbeschreibung_Freifeld_O_Datenfeld, maxLength: 2500 },
				{ ...P.Projektbeschreibung_Ziel_Des_Projekts, maxLength: 2500 },
				P.Projektbeschreibung_Zielgruppe_Des_Projekts,

				P.Projektbeschreibung_Zusaetzliche_Angaben_Zum_Projekt,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

export const GetProjektBeschreibungFormStruc = (application: any, readOnly: boolean) => {
	return concat(
		ProjektDatenSpalte1(application, readOnly),
		ProjektDatenSpalte2(),
		ProjektbeschreibungSpalte1(),
		ProjektbeschreibungTextboxen(),
	);
};
